module.exports = __webpack_public_path__ + "img/shou.58c6727e.png";